/**
 * Checks if the current hostname is a local development environment
 *
 * @returns boolean - true if the hostname is localhost or 127.0.0.1, false otherwise
 */
export default function isLocal() {
  if (typeof window === 'undefined') {
    return false;
  }

  const hostname = window.location.hostname;
  return hostname === 'localhost' || hostname === '127.0.0.1';
}
